// extracted by mini-css-extract-plugin
export default {"root":"CollapseHeader_root__0AMzO","clickable":"CollapseHeader_clickable__UmWDy","content":"CollapseHeader_content__xIOh8"};